export const splitStringIntoLines = (string: string, maxLineLength: number, maxLines: number) => {
  const regex = new RegExp(String.raw`\S.{1,${maxLineLength}}\S(?= |$)`, 'g');
  const lines = string.match(regex) || [];
  const linesToShow = lines?.slice(0, maxLines);
  if (lines.length > linesToShow.length) {
    linesToShow[linesToShow.length - 1] += '...';
  }
  return linesToShow;
};
